import { z } from 'zod';
import { SchemaTimestamp } from '@axiom/types';

export const CandidateRateDiscountSchema = z.object({
  applyUntilDate: SchemaTimestamp,
  multiple: z.number().positive(),
});

export type CandidateRateDiscount = z.infer<typeof CandidateRateDiscountSchema>;
